var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioEngineerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4055 4.67086C23.5365 1.69675 19.6326 0.0162281 15.5548 0H15.4375C6.9116 0 8.9407e-08 7.09349 8.9407e-08 15.8438V24.375C8.9407e-08 26.3943 1.59499 28.0312 3.5625 28.0312H5.9375C7.90501 28.0312 9.5 26.3943 9.5 24.375V18.2812C9.5 16.262 7.90501 14.625 5.9375 14.625H2.42844C3.04247 7.72162 8.68316 2.43715 15.4375 2.4375H15.537C22.2627 2.46666 27.8599 7.74887 28.451 14.625H24.9375C22.97 14.625 21.375 16.262 21.375 18.2812V24.375C21.375 26.3943 22.97 28.0312 24.9375 28.0312H27.3125C29.28 28.0312 30.875 26.3943 30.875 24.375V15.8438C30.8906 11.658 29.2825 7.63786 26.4055 4.67086V4.67086ZM5.9375 17.0625C6.59334 17.0625 7.125 17.6082 7.125 18.2812V24.375C7.125 25.0481 6.59334 25.5938 5.9375 25.5938H3.5625C2.90666 25.5938 2.375 25.0481 2.375 24.375V17.0625H5.9375ZM28.5 24.375C28.5 25.0481 27.9683 25.5938 27.3125 25.5938H24.9375C24.2817 25.5938 23.75 25.0481 23.75 24.375V18.2812C23.75 17.6082 24.2817 17.0625 24.9375 17.0625H28.5V24.375Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEngineerBlue);
export default __webpack_public_path__ + "static/media/audio-engineer-blue.58b107e507056cb167c700c9f684b65e.svg";
export { ForwardRef as ReactComponent };